import { useCallback } from 'react';
import { useRecoilValue } from 'recoil';
import { currentTransState } from '../../../atoms';
import { useUpdateSessionCart } from '../useUpdateSessionCart';
import { useDuplicateTransItem, useSendTransItem } from '../api';

export const useDuplicateCartItem = (): ((id: string) => void) => {
	// const addCartItem = useAddCartItem();
	const updateSessionCart = useUpdateSessionCart();
	const sendTransItem = useSendTransItem(updateSessionCart);
	// const duplicateTransItem = useDuplicateTransItem(updateSessionCart);
	const duplicateTransItem = useDuplicateTransItem(() => sendTransItem());
	const currentTrans = useRecoilValue(currentTransState);

	return useCallback(
		id => {
			const index = currentTrans?.items.findIndex(
				transItem => transItem.id === id
			);

			if (index !== undefined && index > -1) {
				duplicateTransItem(index);
			}
		},
		[currentTrans, duplicateTransItem]
	);
};
